export default __webpack_public_path__ + "static/media/acces-concert.874b2ab8.png";